import { useCallback, useEffect, useState } from 'react';

const zipcodeEventName = 'zipcodeUpdate';

const useZipcode = () => {
  const [zipcode, setZipcode] = useState(
    localStorage.getItem('userZipCode') || ''
  );

  const triggerZipcodeUpdate = useCallback((value: string) => {
    localStorage.setItem('userZipCode', value);
    const customEvent = new CustomEvent(zipcodeEventName, {
      detail: {
        zipcode: value,
      },
    });
    window.dispatchEvent(customEvent);
    setZipcode(value);
  }, []);

  useEffect(() => {
    const handleZipcodeUpdate = (event: any) => {
      setZipcode(event.detail.zipcode);
    };

    window.addEventListener(zipcodeEventName, handleZipcodeUpdate);

    return () => {
      window.removeEventListener(zipcodeEventName, handleZipcodeUpdate);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { zipcode, triggerZipcodeUpdate };
};

export default useZipcode;
